import { Gauge, Activity, Timer } from 'lucide-react';
import { useI18n } from '@/context/I18nContext';

export type CornerMetric = 'speed' | 'rpm' | 'duration';

interface CornerMetricTabsProps {
  activeMetric: CornerMetric;
  onMetricChange: (metric: CornerMetric) => void;
}

export function CornerMetricTabs({ activeMetric, onMetricChange }: CornerMetricTabsProps) {
  const { t } = useI18n();

  const metrics: Array<{ id: CornerMetric; label: string; icon: typeof Gauge; color: string }> = [
    { id: 'speed', label: t('corner.metricSpeed'), icon: Gauge, color: 'text-accent' },
    { id: 'rpm', label: t('corner.metricRpm'), icon: Activity, color: 'text-yellow' },
    { id: 'duration', label: t('corner.metricDuration'), icon: Timer, color: 'text-green' },
  ];

  return (
    <div className="flex items-center gap-1 p-1 bg-bg-surface border border-border-subtle rounded-xl max-w-md mx-auto w-full">
      {metrics.map((metric) => {
        const isActive = activeMetric === metric.id;
        const Icon = metric.icon;

        return (
          <button
            key={metric.id}
            onClick={() => onMetricChange(metric.id)}
            className={`
              flex-1 flex items-center justify-center gap-2 py-2 px-3 rounded-lg text-xs font-semibold transition-all duration-150 cursor-pointer
              ${isActive
                ? 'bg-accent/15 text-accent shadow-xs border border-accent/30'
                : 'text-text-secondary hover:text-text-primary hover:bg-bg-hover border border-transparent'
              }
            `}
          >
            <Icon size={15} className={isActive ? metric.color : 'text-text-muted'} />
            <span>{metric.label}</span>
          </button>
        );
      })}
    </div>
  );
}
